import React, { Suspense } from 'react';
import { Spin } from 'antd';

export const Spinner = () => (
  <div style={{ padding: 50, textAlign: 'center' }}>
    <Spin tip="Loading..." />
  </div>
);

const LoadingSpinner = ({ children }: any) => {
  if (typeof window === 'undefined') {
    return children;
  }

  return <Suspense fallback={Spinner}>{children}</Suspense>;
};

export default LoadingSpinner;
